// モジュール
pjax = require('jquery-pjax');
var showAnimation = require('./module/show_animation.js');
var setSelect = require('./module/set_select.js');

var pjaxControl = {
	init: function() {
		this.setParameter();
		this.bindEvent();
	},
	setParameter: function() {
		this.$target = $('#js-article-list');
		this.$selectWrap = $('#js-change-wrap');
		this.$select = this.$selectWrap.find('#js-change');
		this.pageOutFlg = false;
	},
	bindEvent: function() {
		var that = this,
			url,
			category;

		this.$select.on('change', function() {
			url = $(this).find('option:selected').data('href');
			category = $(this).val();
			that.setAnimation(url);
			that.changeSelectStyle(category);
		});
		$(document).on('animationend.bounceOut', '.js-article', function() {
			if(that.pageOutFlg) {
				$.pjax({
					type: 'POST',
					url: url,
					container: '#js-article-list',
					fragment: '#js-article-list',
					data : {parameter1 : 'change' },
					scrollTo: false,
					timeout: 30000
				});
				that.pageOutFlg = false;
			}
		});
		$(document).on('pjax:error', function() {
			alert('error');
		});
		$(document).on('pjax:timeout', function() {
			alert('タイムアウトしました。');
		});
		$(document).on('pjax:end', function() {
			// リクエスト前に戻す
			$('.js-article').removeClass('bounceOut');
			$('.js-loading').css('opacity', '1');

			// 初期表示時のアニメーション
			showAnimation.init();
			//もっと見るを押した時の処理
			showMore.init();
			$('#js-article-list-btn').find('a').attr('data-php', category);
		});
	},
	setAnimation: function(url) {
		var $targetList = this.$target.find('.js-article'),
			endCount = 0,
			that = this;

		if($targetList.length === 0) {
			$.pjax({
				type: 'POST',
				url: url,
				container: '#js-article-list',
				fragment: '#js-article-list',
				data : {parameter1 : 'change' },
				scrollTo: false,
				timeout: 30000
			});
			that.pageOutFlg = false;
		} else {
			var repeat = setInterval(function() {
				if(endCount >= $targetList.length) {
					that.pageOutFlg = true;
					clearInterval(repeat);
				} else {
					$targetList.eq(endCount).addClass('bounceOut');
					endCount++;
				}
			},80);
		}
	},
	changeSelectStyle: function(category) {
		switch(category) {
			case 'all':
				this.$selectWrap.addClass('is-all').removeClass('is-job is-house is-live is-people is-country');
				break;
			case 'job':
				this.$selectWrap.addClass('is-job').removeClass('is-all is-house is-live is-people is-country');
				break;
			case 'house':
				this.$selectWrap.addClass('is-house').removeClass('is-all is-job is-live is-people is-country');
				break;
			case 'live':
				this.$selectWrap.addClass('is-live').removeClass('is-all is-job is-house is-people is-country');
				break;
			case 'people':
				this.$selectWrap.addClass('is-people').removeClass('is-all is-job is-house is-live is-country');
				break;
			case 'country':
				this.$selectWrap.addClass('is-country').removeClass('is-all is-job is-house is-live is-people');
				break;
			case 'used':
				this.$selectWrap.addClass('is-used').removeClass('is-all is-rent is-store is-land');
				break;
			case 'rent':
				this.$selectWrap.addClass('is-rent').removeClass('is-all is-used is-store is-land');
				break;
			case 'store':
				this.$selectWrap.addClass('is-store').removeClass('is-all is-used is-rent is-land');
				break;
			case 'land':
				this.$selectWrap.addClass('is-land').removeClass('is-all is-used is-rent is-store');
				break;
		}
	}
};

var showMore = {
	init: function() {
		this.setParameter();
		this.bindEvent();
	},
	setParameter: function() {
		this.$target = $('#js-article-list');
		this.$targetUl = this.$target.find('.js-article-ul');
		this.$btnWrap = $('#js-article-list-btn');
		this.$btn = this.$btnWrap.find('a');
	},
	bindEvent: function() {
		var that = this,
			categoryUrl,
			btnData;

		this.$btn.on('click', function(e) {
			e.preventDefault();
			categoryUrl = that.$btn.attr('href');
			btnData = that.$btn.data('php');
			that.setAjax(categoryUrl, btnData);
		});
	},
	setAjax: function(categoryUrl, btnData) {
		var that = this;

		$.ajax({
			type: 'POST',
			url: categoryUrl,
			dataType: 'html',
			data : {slug_name : btnData},
			success: function(data) {
				that.setContent(data);
			},
			error: function() {
				alert('error');
			}
		});
	},
	setContent:function(data) {
		this.$targetUl.append(data);

		// 取得したコンテンツを表示
		showAnimation.init();

		// ボタンを消す
		this.$btnWrap.addClass('isDisplayNone');
	}
};

$(function(){
	//もっと見るを押した時の処理
	showMore.init();
	// コンテンツによってselectタグのvalを切り替える
	setSelect.init();
	// pjax
	pjaxControl.init();
});

$(window).on('load', function(){
	// 初期表示時のアニメーション
	showAnimation.init();
});


/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/article_list.js
 ** module id = 0
 ** module chunks = 8
 **/